import { FC, useContext, useMemo } from 'react';
import { useLoadImage, uuid } from '@repo-level/core-front';

import { useMedia } from 'modules/common/hooks/useMedia';

import { BackgroundConfig, BackgroundContext } from 'contexts/background';

import { ScBackground } from './styled';

export const Background = () => {
  const { backgroundConfig } = useContext(BackgroundContext);

  const [config, key] = useMemo(() => {
    return [backgroundConfig, uuid()];
  }, [backgroundConfig]);

  return config ? <BackgroundInner key={key} {...config} /> : null;
};

const BackgroundInner: FC<BackgroundConfig> = ({
  deskImage,
  mobImage,
  deskPositionX = 'left',
  mobSize,
  deskSize,
  mobPositionX = 'center',
}) => {
  const { isMobileS } = useMedia();
  const currentImage = useMemo(
    () => (isMobileS && mobImage ? mobImage : deskImage),
    [deskImage, isMobileS, mobImage]
  );

  const { loadedImage, loading } = useLoadImage(currentImage);

  return (
    <ScBackground
      $loading={loading}
      $image={loadedImage}
      mobSize={mobSize}
      deskPositionX={deskPositionX}
      deskSize={deskSize}
      mobPositionX={mobPositionX}
    >
      <div />
    </ScBackground>
  );
};
